import React from 'react';
import './PrivacyMarkAnnouncement.css';
import { useNavigate } from 'react-router-dom';

const PrivacyMarkAnnouncement: React.FC = () => {
    const navigate = useNavigate();
    const handleReturn = () => {
        navigate('/');
    };

    return (
        <div className="privacy-mark-announcement-page">
            <button className="return-button" onClick={handleReturn}>
              ←
            </button>
            <div className="announcement-header">
                <h1>プライバシーマーク付与認定のお知らせ</h1>
                <img
                    src="/images/19001774_jp.png"
                    alt="プライバシーマーク 第19001774(01)号"
                    className="privacy-mark-logo"
                />
                <p className="privacy-mark-registration-number">登録番号：第19001774(01)号</p>
            </div>
            <div className="announcement-content">
                <p>当社は、2026年8月24日、一般財団法人日本情報経済社会推進協会（JIPDEC）より「プライバシーマーク」の付与認定を受けました。</p>
                <p>個人情報を適切に取り扱う体制を整備している事業者として認定されたことを機に、お客様に一層安心してサービスをご利用いただける体制を整えてまいります。</p>
            </div>
            <div className="announcement-section">
                <h2>プライバシーマークとは</h2>
                <p>プライバシーマーク制度は、日本産業規格「JIS Q 15001 個人情報保護マネジメントシステム－要求事項」に適合して個人情報を適切に取り扱う体制を整備している事業者を認定し、その旨を示すマークの使用を認める制度です。</p>
                <p>付与認定を受けた事業者は、個人情報の取得から利用、保管、廃棄に至るまでの一連の取り扱いについて、継続的に改善する仕組みを運用することが求められます。</p>
            </div>
            <div className="announcement-section">
                <h2>認定概要</h2>
                <table className="certification-table">
                    <tbody>
                        <tr>
                            <th>認定規格</th>
                            <td>JIS Q 15001:2023</td>
                        </tr>
                        <tr>
                            <th>登録番号</th>
                            <td>第19001774(01)号</td>
                        </tr>
                        <tr>
                            <th>付与機関</th>
                            <td>一般財団法人日本情報経済社会推進協会（JIPDEC）</td>
                        </tr>
                        <tr>
                            <th>認定日</th>
                            <td>2026年8月24日</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="announcement-section">
                <h2>個人情報の取り扱いについて</h2>
                <p>当社における個人情報の取り扱いについては、個人情報保護方針をご覧ください。</p>
                <p>
                    <button
                        type="button"
                        className="privacy-policy-link"
                        onClick={() => navigate('/privacy-policy')}
                    >
                        個人情報保護方針
                    </button>
                </p>
            </div>
            <div className="announcement-section">
                <h2>今後の取り組み</h2>
                <p>当社は、本認定を機に、個人情報保護マネジメントシステムの継続的な改善に努め、お客様の大切な個人情報を守りながら、高品質なサービスの提供に邁進してまいります。</p>
                <p>今後ともご愛顧賜りますよう、よろしくお願い申し上げます。</p>
            </div>
        </div>
    );
};

export default PrivacyMarkAnnouncement;
